import React from "react";
import { CheckCircle } from "lucide-react";
import { Button } from "../ui";

interface ForgotPasswordSuccessProps {
  onBackToLogin: () => void;
}

const ForgotPasswordSuccess: React.FC<ForgotPasswordSuccessProps> = ({
  onBackToLogin,
}) => {
  return (
    <div className="w-full max-w-sm">
      <div className="text-center mb-8">
        <CheckCircle className="text-green-500 mx-auto mb-4" size={48} />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Email đã được gửi
        </h1>
        <p className="text-gray-600 text-sm">
          Vui lòng kiểm tra email của bạn để đặt lại mật khẩu
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6">
        <Button onClick={onBackToLogin} variant="primary" size="md">
          Quay lại đăng nhập
        </Button>
      </div>
    </div>
  );
};

export default ForgotPasswordSuccess;
